import React from 'react'

import {
    Modal,
    Input,
    Button,
    Row,
    message
} from 'antd'

const MAX_LENGTH = 400

class ExcerptEditor extends React.Component{

    state = {
        excerpt: this.props.getExcerpt().slice(0, 400)
    }

    render(){

        const { excerpt } = this.state

        return(
            <div>
                {
                    this.state.render && (
                        <Modal
                            onOk={this.handleOk}
                            onCancel={this.handleClose}
                            afterClose={this.handleAfterClose}
                            visible={this.state.visible}
                            centered
                            closable={false}
                        >
                            <Input.TextArea
                                onChange={this.handleInputChange}
                                rows={10}
                                defaultValue={excerpt}
                            />
                            <Row type="flex" justify="end">
                                <span>
                                    <span
                                        style={{
                                            color: excerpt.length > MAX_LENGTH?'red':''
                                        }}
                                    >{excerpt.length}</span> / {MAX_LENGTH}
                                </span>
                            </Row>
                        </Modal>
                    )
                }
                <Button
                    onClick={this.handleOpen}
                >Excerpt</Button>
            </div>
        )
    }

    handleInputChange = (e) => {

        this.setState({
            excerpt: e.target.value
        })

    }

    handleAfterClose = () => {
        this.setState({
            render: false
        })
    }

    handleClose = () => {
        this.setState({
            visible: false
        })
    }

    handleOpen = () => {

        this.props.getExcerpt()

        this.setState({
            render: true,
            visible: true
        })
    }

    handleOk = () => {
        
        const { excerpt } = this.state

        if( excerpt.length > MAX_LENGTH ){
            return message.error('Excerpt is too long!')
        }

        // this.props.update(excerpt)

        this.handleClose()

    }
}

export default ExcerptEditor


// WEBPACK FOOTER //
// ./src/components/docs/excerpt-editor.js